import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconSwitchToExchangeTransparent = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            fill="none"
            viewBox="0 0 16 17"
        >
        <path
            fill={color}
            d="M12.25 3.066a.783.783 0 01.887.185l1.624 1.713A.88.88 0 0115 5.57a.88.88 0 01-.239.606l-1.624 1.713a.778.778 0 01-.886.185.859.859 0 01-.503-.792v-.852h-.812a.794.794 0 00-.65.343L9.21 8.285 8.194 6.857l.792-1.113a2.394 2.394 0 011.95-1.029h.812v-.857c0-.345.198-.658.503-.792zM6.164 9.715l1.016 1.427-.792 1.114a2.394 2.394 0 01-1.95 1.028H2.812c-.449 0-.812-.383-.812-.857s.363-.857.812-.857h1.625a.794.794 0 00.65-.342l1.076-1.513zm6.971 5.034a.779.779 0 01-.886.185.86.86 0 01-.502-.793v-.857h-.81c-.767 0-1.49-.38-1.95-1.028l-3.9-5.484a.794.794 0 00-.649-.343H2.812c-.449 0-.812-.383-.812-.857s.363-.857.812-.857h1.625c.767 0 1.49.38 1.95 1.029l3.899 5.484a.794.794 0 00.65.342h.812v-.857c0-.345.198-.658.503-.792a.783.783 0 01.886.185l1.624 1.713a.88.88 0 01.239.606.88.88 0 01-.239.605l-1.624 1.713-.003.006z"
        ></path>
        </svg>
    </div>
);

export default IconSwitchToExchangeTransparent;
